import React, { Component } from "react";
import { format } from "date-fns";
import ja from "date-fns/locale/ja";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

import FontPBold from "../atoms/fonts/FontPBold";
import FontPSmall from "../atoms/fonts/FontPSmall";
import Card from "./Card";
import { japaneseList } from "../../Resources/japaneseList";

const styles = (theme) => ({
  rejected: {
    color: "#BBB !important",
  },
  symbolIcon: {
    fontFamily: "none",
  },
});

class Appointment extends Component {
  render() {
    const { appointment, classes } = this.props;
    let styleClass, smallContent;
    switch (appointment.status) {
      case "rejected":
        styleClass = classes.rejected;
        smallContent = (
          <FontPSmall style={{ color: "#F26666" }}>
            <span className={classes.symbolIcon}>▲</span>
            {japaneseList.molecules.Appointment.textRejected}
          </FontPSmall>
        );
        break;
      case "unapproved":
        smallContent = (
          <FontPSmall style={{ color: "#305D95" }}>
            <span className={classes.symbolIcon}>▲</span>
            {japaneseList.molecules.Appointment.textUnapproved}
          </FontPSmall>
        );
        break;
      default:
        break;
    }

    return (
      <div>
        <Card>
          <FontPBold className={styleClass}>
            {appointment.hospitalName}
          </FontPBold>
          <FontPSmall className={styleClass}>
            {format(appointment.from, "YYYY/MM/DD （dd） HH:mm", {
              locale: ja,
            })}
            ～{format(appointment.to, "HH:mm")}の枠
          </FontPSmall>
          {smallContent}
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Appointment));
